import { Authorization } from '../model/authorization';
import { DeliveryPackage } from '../model/deliveryPackage';
import { Invite } from '../model/invite';
export class DataNavigation {
  SelectedAuthorization: Authorization;
  SelectedInvite: Invite;
  SelectedDeliveryPackage: DeliveryPackage;
  AllowedRoles: string[] = [];
  AllowedUnits: number[] = [];
  UserRegisterCallback: Function;
  LoadPicture: boolean = false;
  ConfirmedAuth: boolean = false;
  IsViewingAuth: boolean = false;
  IsEditAuth: boolean = false;


  selectAuthorization(authorization: Authorization,  allowedUnits: number[] = [], userRegisterCallback?) {
      this.IsEditAuth = true;
      this.SelectedAuthorization = authorization;
      this.AllowedRoles = [authorization.role];
      this.AllowedUnits = allowedUnits;
      
      this.UserRegisterCallback = userRegisterCallback;
  }

  setNewAuthorization(allowedRoles: string[], allowedUnits: number[], userRegisterCallback?) {
    this.IsEditAuth = false;
    this.SelectedAuthorization = undefined;
    this.AllowedRoles = allowedRoles;
    this.AllowedUnits = allowedUnits;
    
    this.UserRegisterCallback = userRegisterCallback;
  }

  isRoleAllowed(role: string): boolean {
    if (this.AllowedRoles.length > 0) {
      return this.AllowedRoles.some(r => role.includes(r));
    }
    return false;
  }

  isUnitAllowed(unitId: number): boolean {
    if (this.AllowedUnits.length > 0) {
      return this.AllowedUnits.some(u => unitId == u);
    }
    return true;
  }
}
